export function togglePrices() {
    if (document.querySelectorAll('.js-toggle-prices').length > 0) {

        let priceType = sessionStorage.getItem('priceType') || 'user';
        const togglePricesBtn = document.querySelector('.js-toggle-prices');

        if (sessionStorage.getItem('priceType') === 'customer') {
            togglePricesBtn.querySelector('.show-prices').style.display = 'none';
            togglePricesBtn.querySelector('.hide-prices').style.display = '';
        } else {
            togglePricesBtn.querySelector('.show-prices').style.display = '';
            togglePricesBtn.querySelector('.hide-prices').style.display = 'none';
        }

        togglePricesBtn.addEventListener('click', function (e) {

            e.preventDefault();
            const showIcon = this.querySelector('.show-prices');
            const hideIcon = this.querySelector('.hide-prices');
            // const prices = document.querySelectorAll('.price');

            if (showIcon.style.display === 'none') {
                showIcon.style.display = '';
                hideIcon.style.display = 'none';
                priceType = 'user';
            } else {
                showIcon.style.display = 'none';
                hideIcon.style.display = '';
                priceType = 'customer';
            }

            sessionStorage.setItem('priceType', priceType);

            var cartSubtotalElement = document.querySelector('.cart-subtotal-price');
            var cartTotalElement = document.querySelector('.cart-total-price');
            var shippingTotalElement = document.querySelector('.shipping-total');

            if (cartTotalElement) {
                var subtotalsElements = document.querySelectorAll('.cart-detail-total');
                subtotalsElements.forEach(el => {
                    var price = el.getAttribute('data-price');
                    el.innerHTML = priceType === 'customer' ? '... + IVA' : `<span class="price">€ ${parseFloat(price).toFixed(2).replace('.', ',')}</span>`;
                });

                if (cartSubtotalElement && shippingTotalElement && cartTotalElement) {
                    var subtotal = cartSubtotalElement.getAttribute('data-total');
                    var total = subtotal;

                    var shippingTotal = document.querySelector('.shipping-total');
                    var shippingPrice = shippingTotal.getAttribute('data-shipping-amount') || 0;

                    total = parseFloat(total) + parseFloat(shippingPrice);

                    shippingTotalElement.innerHTML = priceType === 'customer' ? '...' : `<span class="price">€ ${parseFloat(shippingPrice).toFixed(2).replace('.', ',')}</span>`;
                    cartSubtotalElement.innerHTML = priceType === 'customer' ? '... + IVA' : `<span class="total">€ ${parseFloat(subtotal).toFixed(2).replace('.', ',')}</span>`;
                    cartTotalElement.innerHTML = priceType === 'customer' ? '... + IVA' : `<span class="total">€ ${parseFloat(total).toFixed(2).replace('.', ',')}</span>`;
                } else {
                    var subtotal = cartTotalElement.getAttribute('data-total');
                    var total = subtotal;

                    cartTotalElement.innerHTML = priceType === 'customer' ? '... + IVA' : `<span class="total">€ ${parseFloat(total).toFixed(2).replace('.', ',')}</span>`;
                }
            }
        });

    }
}